import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_txn_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}

export class bl_inv_txn_hdr_RowClass implements bl_inv_txn_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}
